import useSWR from 'swr'

import { IInvoice } from '../types'
import createRestClient from './createRestClient'
import useBillingInfo from './useBillingInfo'
import useOrganization from './useOrganization'

export default function useInvoices() {
  const organization = useOrganization()
  const { subscription } = useBillingInfo()

  const { data, error } = useSWR(
    () => {
      if (organization === undefined) {
        throw new Error('organization was not loaded')
      }

      if (subscription?.id === undefined) {
        throw new Error('subscription was not loaded')
      }

      return [organization.workspaceId, subscription.id]
    },
    async ([workspaceId, subscriptionId]: [string, string]) => {
      const response = await createRestClient(workspaceId).get<Array<IInvoice>>(
        `subscriptions/${subscriptionId}/invoices`,
      )
      return response ?? []
    },
  )

  if (error) {
    throw error
  }

  return data
}
